import { makeMyDate } from "./_date-utils";
import { makeExhibitorDetailUrl, makeNewsDetailUrl } from "./_route-utils";
import Exhibitor from "./interfaces/_Exhibitor";
import News from "./interfaces/_News";


export function makeNewsCard(news: News): HTMLElement {
  const cardElement = document.createElement("a");
  cardElement.classList.add("c-card-news");
  cardElement.href = makeNewsDetailUrl(news.id);
  const dateElement = document.createElement("div");
  dateElement.classList.add("c-card-news__date");
  cardElement.appendChild(dateElement);
  if (news.publishedAt) {
    dateElement.textContent = makeMyDate(news.publishedAt);
  }
  const titleElement = document.createElement("h1");
  titleElement.classList.add("c-card-news__title");
  cardElement.appendChild(titleElement);
  titleElement.textContent = news.title;
  return cardElement;
}

export function makeExhibitorCard(exhibitor: Exhibitor): HTMLElement {
  const cardElement = document.createElement("a");
  cardElement.classList.add("c-card-exhibitors");
  cardElement.href = makeExhibitorDetailUrl(exhibitor.id);

  const thumbnailElement = document.createElement("img");
  thumbnailElement.classList.add("c-card-exhibitors__thumbnail");
  thumbnailElement.alt = "";
  thumbnailElement.src = exhibitor.posterThumbnailImage.url;
  cardElement.appendChild(thumbnailElement);
  const titleElement = document.createElement("h1");
  titleElement.classList.add("c-card-exhibitors__title");
  cardElement.appendChild(titleElement);
  titleElement.textContent = exhibitor.title;
  const companyNameElement = document.createElement("h1");
  companyNameElement.classList.add("c-card-exhibitors__company-name");
  cardElement.appendChild(companyNameElement);
  companyNameElement.textContent = exhibitor.companyName;


  return cardElement;
}

